// =============================================================================
// alpha.js — une couleur à une opacité donnée (lot L2, 27/09/2026).
//
// Depuis le lot L10a (codemod l10a-alpha), il remplace les 1 510
// concaténations de suffixe hex (C.teal + "22") qui interdisaient de faire
// passer C à des jetons var(--acc-*) : « var(--acc-teal)22 » n'est pas une
// couleur. Ne jamais réécrire de concaténation (cliquet à venir, §L10).
//
//   alpha(C.teal, .13)            → "rgba(29,148,138,0.13)"
//   alpha("var(--acc-teal)", .08) → "color-mix(in srgb, var(--acc-teal) 8%, transparent)"
//
// Hex (#RGB, #RGBA, #RRGGBB, #RRGGBBAA) : rgba() exact, compris partout, et
// identique au pixel près au suffixe hex d'aujourd'hui (3 décimales suffisent à
// retomber sur le même octet : C.teal+"22" ⇔ alpha(C.teal, 0x22/255)).
// Toute autre couleur (jeton var(--…), nom, rgb()) : color-mix(), la technique
// que theme.css et Header.js emploient déjà. Repli si le navigateur ne connaît
// pas color-mix() (Safari < 16.2) : la couleur opaque — mieux vaut un aplat
// visible qu'un élément invisible. Dans un style EN LIGNE on ne peut pas écrire
// deux valeurs en cascade : le choix se fait donc ici, une fois, au premier appel.
//
// Module sans dépendance ; réexporté par appShared.js.
// =============================================================================

const HEX = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

let colorMixOk;
export function colorMixDisponible() {
  if (colorMixOk === undefined) {
    try {
      colorMixOk = typeof CSS !== "undefined" && typeof CSS.supports === "function"
        && CSS.supports("color", "color-mix(in srgb, red 50%, transparent)");
    } catch { colorMixOk = false; }
  }
  return colorMixOk;
}
/** Tests uniquement : oublie la détection de color-mix(). */
export function reinitialiserDetectionAlpha() { colorMixOk = undefined; }

const borner = (a) => {
  const n = Number(a);
  return Number.isFinite(n) ? Math.min(1, Math.max(0, n)) : 1;
};
const arrondi = (x) => Math.round(x * 1000) / 1000;

export function alpha(couleur, a) {
  const k = borner(a);
  const c = typeof couleur === "string" ? couleur.trim() : "";
  if (!c) return "transparent";
  const m = HEX.exec(c);
  if (m) {
    let h = m[1];
    if (h.length <= 4) h = h.split("").map((x) => x + x).join("");
    const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    const base = h.length === 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1;
    return `rgba(${r},${g},${b},${arrondi(base * k)})`;
  }
  if (colorMixDisponible()) return `color-mix(in srgb, ${c} ${arrondi(k * 100)}%, transparent)`;
  return c;
}
